import { useEffect } from 'react';
import { notification, Spin } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { IBrowserRouteProps } from '../../router';
import { useApiFetch } from '../../hooks/api/useApiFetch';

const AvitoAuthPage = ({ hideHashRouter }: IBrowserRouteProps) => {
    const api = useApiFetch();
    const [searchParams] = useSearchParams();
    const code = searchParams.get('code');
    const navigate = useNavigate();

    const navigateToAccountsList = () => {
        navigate('/#/avito-accounts/list');
    };

    const auth = async () => {
        const response = await api.fetchData('/avito-accounts/auth', 'post', true, { code });
        if (!response.success) {
            notification.error({ message: response.message });
        }
        navigateToAccountsList();
    };

    useEffect(() => {
        if (typeof code === 'string' && code.length > 0) {
            auth();
            hideHashRouter(true);
        } else {
            navigateToAccountsList();
        }
    }, []);

    return (
        <div className="d-flex flex-1 align-items-center justify-content-center">
            <Spin spinning tip="Авторизация" />
        </div>
    );
};

export default AvitoAuthPage;
